/**
 * Copy to clipboard element.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Fab from '@material-ui/core/Fab';
import ContentCopyIcon from './ContentCopyIcon/ContentCopyIcon';

const propTypes = {
  copyString: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    hidden: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  copySuccess: PropTypes.bool.isRequired,
  copyStyles: PropTypes.shape({}).isRequired,
  size: PropTypes.string.isRequired,
  checkColor: PropTypes.string.isRequired,
};

export function UnStyledCopyToClipboard({
  copyString,
  classes,
  setUiState,
  copySuccess,
  copyStyles,
  size,
  checkColor,
}) {
  const handleCopy = () => {
    if (copySuccess) {
      return;
    }
    const tempInput = document.createElement('input');
    tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
    tempInput.value = copyString;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    setUiState({ copySuccess: true });
    setTimeout(() => {
      setUiState({ copySuccess: false });
    }, 3000);
  };

  return (
    <div className={!document.queryCommandSupported('copy') ? classes.hidden : null}>
      <Fab style={copyStyles} size={size} aria-label="Copy to clipboard" onClick={handleCopy}>
        {copySuccess ? <CheckCircle color={checkColor} /> : <ContentCopyIcon />}
      </Fab>
    </div>
  );
}

UnStyledCopyToClipboard.propTypes = propTypes;

const styles = (theme) => ({
  hidden: {
    color: '#000',
    visibility: 'hidden',
    display: 'none',
    height: 0,
  },
  svg: {
    fill: theme.palette.text.primary,
  },
});

export const uiConfig = {
  name: 'copyToClipboard',
  state: () => ({
    copySuccess: false,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnStyledCopyToClipboard));
